import "./Management.css";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../authContext";
import AdminContent from "./administrators";
import UsersContent from "./users"
import AssistantContent from "./assistants";
import ResourceContent from "./resource";
import GroupsContent from "./groups";

function Management({ assistant, sessionId, selfAssistant = false }) {
  const { t: tManagement } = useTranslation("management");
  const { t: tCommon } = useTranslation("common");
  const { isManager } = useContext(AuthContext);

  const [tipo, setTipo] = useState("assistente");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const [hidePublishInput, setHidePublishInput] = useState(false);

  const handleTipoChange = (newTipo) => {
    setTipo(newTipo);
    setSearchTerm("");
  };

  return (
    <div className="management">
      <section className="management-painel">
        <img
          src="/imagens/iris-logo.svg"
          className="management-painel-logo"
          alt=""
        />
        <div class="linha"></div>
        <div className="button-group">
          <button
            data-testid="button-search-management"
            className={`button-search-management ${tipo === "assistente" ? "active" : ""}`}
            onClick={() => handleTipoChange("assistente")}
          >
            <img
              src="/imagens/Robot.svg"
              className="management-painel-btn-logo"
              alt=""
            />
            {tManagement("assistentes")}
          </button>
          <button
            data-testid="button-adm"
            className={`button-adm ${tipo === "admin" ? "active" : ""}`}
            onClick={() => handleTipoChange("admin")}
          >
            <img
              src="/imagens/users.svg"
              className="management-painel-btn-logo"
              alt=""
            />
            {tManagement("administrador")}
          </button>
          <button
            data-testid="button-users"
            className={`button-users ${tipo === "users" ? "active" : ""}`}
            onClick={() => handleTipoChange("users")}
          >
            <img
              src="/imagens/users.svg"
              className="management-painel-btn-logo"
              alt=""
            />
            {tManagement("users")}
          </button>
          <button
            data-testid="button-search-resource"
            className={`button-search-resource ${tipo === "resource" ? "active" : ""}`}
            onClick={() => handleTipoChange("resource")}
          >
            <img
              src="/imagens/laptop.svg"
              className="management-painel-btn-logo"
              alt=""
            />
            {tManagement("resourceManagement")}
          </button>
          {isManager && (
            <button
              data-testid="button-search-groups"
              className={`button-search-groups ${tipo === "grupos" ? "active" : ""}`}
              onClick={() => handleTipoChange("grupos")}
            >
              <img
                src="/imagens/users.svg"
                className="management-painel-btn-logo"
                alt=""
              />
              {tManagement("groupManagement")}
            </button>
          )}
        </div>
        <div class="linha"></div>
        <button
            className="button-back"
            onClick={() => {
                localStorage.clear();
                setShowLogout(false)
                navigate('/hub');
              }}
          >
            <img
              src="/imagens/ArrowUUpLeft.svg"
              className="management-painel-btn-logo"
              alt=""
            />
            {tManagement("backHub")}
          </button>
      </section>
      <div className="management-wrapper">
        <div className="management-header">
          {tipo === "users" ? tManagement("users") : tipo === "admin" ? tManagement("administrador") : tipo === "assistente" ? tManagement("assistentes") : tipo === "grupos" ? tManagement("groupManagement") : tManagement("resourceManagement")}
        </div>
        <div className={`management-content${tipo === "resource" ? " management-content--resource" : ""}${tipo === "grupos" ? " management-content--groups" : ""}`}>
          <div className="caroussel-management">
            {tipo === "admin" ? (
              <AdminContent searchTerm={searchTerm} />
            ) : tipo === "users" ? (
              <UsersContent searchTerm={searchTerm} />
            )
              : tipo === "assistente" ? (
              <AssistantContent searchTerm={searchTerm} onTogglePublishInput={setHidePublishInput} />
            ) : tipo === "resource" ? (
              <ResourceContent searchTerm={searchTerm} />
            ) : tipo === "grupos" ? (
              <GroupsContent />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Management;
